import * as Cookies from 'js-cookie';
// eslint-disable-next-line camelcase
import * as jwt_decode from 'jwt-decode';

import some from 'lodash/some';

const AuthorisationUtil = {

  ACCESS_COOKIE_NAME: 'access-token',

  authorities: {
    APPROVE_TIME: 'APPROVE_TIME',
    CAPTURE_CALL_BACK: 'CAPTURE_CALL_BACK',
    CAPTURE_TIME: 'CAPTURE_TIME',
    VIEW_TIME: 'VIEW_TIME',
    ADD_TIME: 'ADD_TIME',
    ASSIGN_WORK_SCHEDULES: 'ASSIGN_WORK_SCHEDULES',
  },

  getAuthToken() {
    return Cookies.get(this.ACCESS_COOKIE_NAME);
  },

  fetchDecodedAuthToken() {
    const jwtCookie = this.getAuthToken();

    return jwtCookie ? jwt_decode(jwtCookie) : null;
  },

  destroyJwt() {
    Cookies.remove(this.ACCESS_COOKIE_NAME);
  },

  employeeHasViewTimeAuthority: () => some(
    AuthorisationUtil.fetchDecodedAuthToken().assignAuths,
    (assignAuth) => (assignAuth.indexOf(AuthorisationUtil.authorities.VIEW_TIME) >= 0),
  ),

  employeeHasCaptureTimeAuthority: () => some(
    AuthorisationUtil.fetchDecodedAuthToken().assignAuths,
    (assignAuth) => (assignAuth.indexOf(AuthorisationUtil.authorities.CAPTURE_TIME) >= 0),
  ),

  isManager: () => some(
    AuthorisationUtil.fetchDecodedAuthToken().auth,
    (auth) => auth.authority === AuthorisationUtil.authorities.APPROVE_TIME,
  ),

  managerCanClockEmployees: () => AuthorisationUtil.isManager() && true,
};

export default AuthorisationUtil;
